import { createFileRoute } from '@tanstack/react-router';
import { validateKnowledgeSearch } from '../lib/knowledge-search.js';
import { KnowledgeRouteComponent } from './knowledge.js';

export const Route = createFileRoute('/$workspaceSlug/knowledge')({
  component: KnowledgeRouteComponent,
  validateSearch: validateKnowledgeSearch,
});
